import { useMutation, useQuery } from "@tanstack/react-query";
import React, { useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import { MdOutlineCheck } from "react-icons/md";
import {
  getAfterRunFinalStatus,
  getEachCellStatus,
  getIsRunEnableForCombineDataStatus,
  getProjectWiseUploadedListAllBucketPath,
  getProjectWiseUploadedListByEmail,
  getTransformationDataQcAllStatus,
  runFinalDataQc,
  runInitialDataQc,
} from "../../../../api/apiCallManager";
import Loader from "../../../../components/spinner/Loader";
import { showError, showSuccess } from "../../../../helpers/alerts";
import WrapperLoader from "../../../../components/spinner/WrapperLoader";
import AccessTo from "../../../../components/is-show/AccessTo";
import { CM, FL } from "../../../router/AddRoutesJson";
import { Tag, Tooltip } from "antd";
import FinalModelDownloadCell from "../FinalModelDownloadCell";
import { CONSTANT_CLIENT_PROGRESS_STATUS } from "./rowConstantStatus";
import LogScriptRunErrorModal from "./LogScriptRunError";

function FinalModelCel({ rowItems, allTableData }) {
  const [isDisabled, setIsDisable] = useState(false);
  const [showLogError, setShowLogError] = useState(false);
  const onRunError = (data) => {
    setShowLogError(true);
    showError("Run Failed", data?.body);
    setIsDisable(false);
  };
  const runMutation = useMutation({
    mutationFn: runInitialDataQc,
    onSuccess: (data) => {
      if (data.statusCode == 200) {
        showSuccess("Script Running...");
        setIsDisable(true);
      } else {
        onRunError(data);
      }
    },
    onError: (error) => {
      onRunError(error);
    },
  });

  const fetchUploadedList = useMutation({
    mutationFn: () =>
      getProjectWiseUploadedListByEmail(rowItems?.siteManager?.email),
    onError: (error) => {
      showError(`Please re-try: ${error.message}`); // Show error alert
    },
    onSuccess: (data) => {
      const filteredFiles =
        data?.filter(
          (file) => file?.siteName === rowItems?.siteManager?.siteName
        ) || [];

      if (filteredFiles.length) {
        const payload = {
          rowItems,
          filteredSpecificSiteFile: filteredFiles,
          eventType: "final_model_qc_script_run",
        };
        runMutation.mutate(payload); // Run mutation after data is fetched
      } else {
        showError("Something Went Wrong! Please retry!");
      }
    },
  });

  const handleRun = () => {
    fetchUploadedList.mutate(); // Trigger the fetch mutation
  };
  const handleFailed = () => {
    setShowLogError(Math.random());
  };
  const renderStatusComponent = (status) => {
    switch (true) {
      case CONSTANT_CLIENT_PROGRESS_STATUS.RUNNING?.includes(status):
        return <Tag color="green">Running</Tag>;
      case CONSTANT_CLIENT_PROGRESS_STATUS.PENDING?.includes(status):
        return (
          <AccessTo
            role={[CM]}
            fallBackComponent={<Tag color="orange"> Run Enabled</Tag>}
          >
            <button
              disabled={isDisabled}
              className="bg-green-600 text-white  px-2 rounded-sm"
              onClick={() => handleRun()}
            >
              {runMutation.isPending || fetchUploadedList.isPending ? (
                <Loader
                  isLoading={
                    runMutation.isPending || fetchUploadedList.isPending
                  }
                />
              ) : (
                "Run"
              )}
            </button>
          </AccessTo>
        );
      case CONSTANT_CLIENT_PROGRESS_STATUS.SUCCESS?.includes(status):
        return <FinalModelDownloadCell rowItems={rowItems} />;
      case CONSTANT_CLIENT_PROGRESS_STATUS.FAILED?.includes(status):
        return (
          <button onClick={handleFailed}>
            <Tag color={"red"}>
              {/* <BsFillInfoCircleFill color="#fd5252" /> */}
              Failed
            </Tag>
          </button>
        );
      default:
        return <IoCloseOutline color="red" size={16} />; // Default case for other statuses
    }
  };

  return (
    <div className="flex justify-center">
      {/* {JSON.stringify(filteredFiles, null, 4)} */}
      {/* <button
        disabled={isDisabled}
        className="bg-green-600 text-white  px-2 rounded-sm"
        onClick={() => handleRun(filteredFiles)}
      >
        {mutation.isPending ? <Loader isLoading={mutation.isPending} /> : "Run"}
      </button> */}
      <LogScriptRunErrorModal
        scriptType={"final-model"}
        rowItems={rowItems}
        showLogError={showLogError}
        setShowLogError={setShowLogError}
      />
      <WrapperLoader isLoading={!rowItems?.celStatus}>
        {renderStatusComponent(rowItems?.celStatus?.final_model_qc?.status)}
      </WrapperLoader>
    </div>
  );
}

export default FinalModelCel;
